import * as CL from '@design-system/component-library';
import { Link } from 'react-router';
import { t } from '../../../../common/i18n/index.js';

export const DnsDomainDisclaimerEnableMfa = () => (
  <CL.Disclaimer
    disclaimerType="info"
    icon={<CL.Icon icon="lock" type="regular" aria-hidden="true" />}
    title={t.PAOF('Activate two-factor authentication')}
    text={t.FDUX(
      'Access to Elisa DNS management requires two-factor authentication. You can activate two-factor authentication on the Company details and settings page.'
    )}
    visible
  >
    <Link to="/omaelisa/yritystiedot/asetukset">
      <CL.Button color="light" size="s">
        {t.COTT('Activate')}
      </CL.Button>
    </Link>
  </CL.Disclaimer>
);
